import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { selectbookingdetails, bookingdetails, selectDetailsLoading } from "../hotel/HotelSlice";
import { selectbookingdetails, bookingdetails, selectDetailsLoading, DopackagePayPending, DoSendVoucher } from "../holiday/HolidaySlice";
import { selectCurrentUser } from "../auth/authSlice";
import { toast } from 'react-hot-toast';
import { format, parseISO } from "date-fns";
import { CheckCircle, Clock, XCircle, Printer, ChevronDown, CircleX } from 'lucide-react';
import { Dialog } from "@headlessui/react";
import CancellationPolicyPopup from "../hotel/CancellationPolicyPopup";
import BookingReviewShimmer from '../hotel/BookingReviewShimmer';
import { getapiKey, getbaseURL } from "../../api/axios";
import ReviewBooking from '../hotel/ReviewBooking';
import CurFt from '../../components/CurFt';
import WalletUtils from '../../utils/walletUtils';
import { usePaymentProcessRecharge } from '../../services/usePaymentProcessRecharge';
const Confirmation = () => {
    const { BookingID, ProID, package_booking_id } = useParams()
    const [showCancellationPopup, setShowCancellationPopup] = useState(true);
    const user = useSelector(selectCurrentUser)
    const selectbookingdetailsData = useSelector(selectbookingdetails)
    const DetailsLoading = useSelector(selectDetailsLoading)
    const location = useLocation();
    const dispatch = useDispatch();
    const [BookingId, setBookingId] = useState([]);
    const [BookingStatus, setBookingStatus] = useState(0);
    const [BookingData, setBookingData] = useState([]);
    const [PackagePrice, setPackagePrice] = useState([]);
    const [checkindate, setcheckindate] = useState(null);
    const [checkoutDate, setcheckoutDate] = useState(null);


    const [memberDetails, setMemberDetails] = useState([])
    const [data, setData] = useState({});

    const CurrencySymbol = BookingData?.currency?.name || "INR"

    useEffect(() => {
        setBookingId(BookingID)
        if (DetailsLoading) {
            setTimeout(() => {
                FetchBookingDetails({
                    FormData: {
                        BookingID: BookingID,
                        ProID: ProID,
                        package_booking_id: package_booking_id,
                    }
                });
            }, 1000);
        }

    }, [location.pathname, BookingStatus, DetailsLoading]);

    useEffect(() => {
        if (!DetailsLoading) {
            const isoDate = selectbookingdetailsData?.BookingData?.TravelDate || null;
            // parse ISO string
            const parsedDate = new Date(isoDate);
            const parsedDateOut = new Date(selectbookingdetailsData?.BookingData?.checkoutDate);
            // format: 20th Jan'26, Thursday
            const checkindate = format(parsedDate, "do MMM yy, EEEE");
            const checkoutDate = format(parsedDateOut, "do MMM yy, EEEE");
            setcheckindate(checkindate)
            setcheckoutDate(checkoutDate)
            setBookingData(selectbookingdetailsData?.BookingData || [])
            setPackagePrice(selectbookingdetailsData?.PackagePrice || [])
            setBookingStatus((selectbookingdetailsData?.BookingData?.status) || 0)
            setMemberDetails((selectbookingdetailsData?.BookingData?.booking_customer) || [])


            setData({
                countryCode: (selectbookingdetailsData?.BookingData?.booking_customer[0]) ? selectbookingdetailsData?.BookingData?.booking_customer[0].countrycode : '91',
                email: (selectbookingdetailsData?.BookingData?.booking_customer[0]) ? selectbookingdetailsData?.BookingData?.booking_customer[0].email : '',
                mobile: (selectbookingdetailsData?.BookingData?.booking_customer[0]) ? selectbookingdetailsData?.BookingData?.booking_customer[0].mobile : '',
                gstnnumber: (selectbookingdetailsData?.BookingData?.booking_customer[0]) ? selectbookingdetailsData?.BookingData?.booking_customer[0].gstnnumber : '',
                companyname: (selectbookingdetailsData?.BookingData?.booking_customer[0]) ? selectbookingdetailsData?.BookingData?.booking_customer[0].companyname : '',
                gstemail: (selectbookingdetailsData?.BookingData?.booking_customer[0]) ? selectbookingdetailsData?.BookingData?.booking_customer[0].gstemail : '',
                gstphone: (selectbookingdetailsData?.BookingData?.booking_customer[0]) ? selectbookingdetailsData?.BookingData?.booking_customer[0].gstphone : '',
                gstaddress: (selectbookingdetailsData?.BookingData?.booking_customer[0]) ? selectbookingdetailsData?.BookingData?.booking_customer[0].gstaddress : '',
                TravelInsurances: (selectbookingdetailsData?.BookingData?.TravelInsurances) ? selectbookingdetailsData?.BookingData?.TravelInsurances : false,
                Forex: (selectbookingdetailsData?.BookingData?.Forex) ? selectbookingdetailsData?.BookingData?.Forex : false,
                accepttnc: true,
                RequestVisa: (selectbookingdetailsData?.BookingData?.RequestVisa) ? selectbookingdetailsData?.BookingData?.RequestVisa : false,
            })
        }
    }, [selectbookingdetailsData]);


    const FetchBookingDetails = async (payload) => {
        try { await dispatch(bookingdetails(payload)).unwrap(); }
        catch (err) { console.error("Fetch failed:", err); }
    };

    const [showCan, setShowCan] = useState(false);
    const [showItin, setShowItin] = useState(false);
    const Image = ({ src, alt, fallback, className }) => {
        const [error, setError] = useState(false);
        const onError = () => {
            setError(true);
        }
        return error ? <img src={fallback} alt={alt} className={className} style={{ width: '333px', height: '200px', overflow: 'hidden' }} /> : <img src={src} alt={alt} className={className} onError={onError} style={{ width: '333px', height: '200px', overflow: 'hidden' }} />;
    }
    const initialFormData = {
        displayServiceFee: 1,
        isVoucher: 1,
        action: 0,
        showPrice: true,
        withBranding: true,
        tax: true,
        withtnc: true,
        hoteldetails: true,
        Itinerary: true,
        emailid: '',
        mobile: '',
        amount: 0,
        Discount: 0,
        countrycode: '',
        Name: '',
        BookingID: BookingData?.BookingID,
    };

    const [Processing, setProcessing] = useState(false);
    const [formData, setFormData] = useState(initialFormData);
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [Titles, setTitles] = useState('');
    const [open, setOpen] = useState(false);
    const [OpenPaynow, setOpenPaynow] = useState(false);

    const [isSectorModalOpen, setIsModalSector] = useState(false);
    const [walletbnplStatus, setwalletbnplStatus] = useState(false);
    const [errorMessage, setErrorMessage] = useState('loading');

    const [errorMessageRecharge, SetErrorMessageRecharge] = useState("loading");
    const [paymentHookStatusRecharge, setpaymentHookStatusRecharge] = useState(null);
    const [ResponseData, SetResponseData] = useState(null);
    const { handleProceedRecharge } = usePaymentProcessRecharge({
        SetErrorMessageRecharge: SetErrorMessageRecharge,
        setpaymentHookStatusRecharge: setpaymentHookStatusRecharge,
        SetResponseData: SetResponseData,
    });

    const handleOpen = (Title, action) => {
        setTitles(Title);
        setDialogOpen(true);
        setFormData(prev => ({
            ...prev,
            ['action']: action,
            ['BookingID']: BookingData?.BookingID,
        }));
    };
    const [paymentMode, SetpaymentMode] = useState("1");
    const paymentModeHandle = (event) => {
        const { value, checked } = event.target;
        SetpaymentMode(value)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let remark = e.target.remark.value;
        let txnid = "TXN" + Date.now()
        let PendingAmount = (PackagePrice?.finalPrice - BookingData?.ReceivedAmount)
        const hash = WalletUtils.walletCode(txnid, txnid, ((PendingAmount)).toFixed(2), user?.UserData?.name, user?.UserData?.mobile, user?.UserData?.email, "Package Pending Payment");
        // const hash = WalletUtils.walletCode(txnid, txnid, ((TotalGrand) - BookAmt).toFixed(2), user?.UserData?.name, user?.UserData?.mobile, user?.UserData?.email, "BNPL Pending Payment");
        // const decrypt = decryptAES('a3a83c379525b1251c7a2660c6ac120a', getapiKey(), getapiKey());
        const customerInfo = {
            txnid: txnid,
            amount: (PendingAmount).toFixed(2),
            name: user?.UserData?.name,
            email: user?.UserData?.email,
            phone: user?.UserData?.mobile,
            productinfo: "Package Pending Payment",
            surl: "http://localhost:3001/payment/payment-success",
            furl: "http://localhost:3001/payment/payment-success",
            udf1: BookingData.BookingID,
            udf2: "3",
            udf3: "Web-B2B",
            udf4: user?.UserData?.user?.id, // customer id
            udf5: user?.UserData?.user?.AgencyID,
            udf6: BookingData?.Currncy?.name || "INR",
            udf7: "",
            udf8: "",
            udf9: "",
            udf10: "",
            securecode: hash,
        };
        if (remark === '') {
            toast.error('Enter your remarks', { autoClose: 2000 });
            return false;
        }

        if (paymentMode === '1') {
            let payload = {
                "customer_id": BookingData?.customer_id,
                "amount": ((PendingAmount)).toFixed(2),
                "currency": BookingData?.Currncy?.name || "INR",
                "BookingID": BookingData.BookingID,
                "Remark": remark
            }
            const confirmed = window.confirm(
                "Are you sure you want to processed?"
            );

            if (!confirmed) {
                return;
            }
            setIsModalSector(true)
            setProcessing(true)
            const response = await dispatch(DopackagePayPending({ payload })).unwrap();
            if (response.data.status.success) {
                toast.success(response.data.message, { autoClose: 2000 });
                setBookingData(response.data?.BookingData || [])
                setPackagePrice(response.data?.PackagePrice || [])
                setwalletbnplStatus(true)
                setErrorMessage('success')
                setProcessing(false)
                setIsModalSector(false)
            } else {
                toast.error(response.data.message, { autoClose: 2000 });
                setProcessing(false)
            }
        } else {
            setProcessing(true)
            setIsModalSector(true)
            handleProceedRecharge(customerInfo);
        }
    };
    useEffect(() => {
        setTimeout(() => {
            if (paymentHookStatusRecharge === "success") {
                setIsModalSector(false);
                setProcessing(false);
                toast.success("Package has been booked successfully", { autoClose: 4000 });
            } else if (paymentHookStatusRecharge === "paymentfailed") {
                setIsModalSector(false);
                setProcessing(false);
                SetErrorMessageRecharge("paymentfailed");
                toast.error("Payment failed. plese contact with support team.", { autoClose: 4000 });
            }
        }, 2000);
    }, [paymentHookStatusRecharge, errorMessageRecharge]);

    function objectToQueryString(obj) {
        return Object.keys(obj)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
            .join('&');
    }
    useEffect(() => {
        const queryString = objectToQueryString(formData);
        if (formData.action === 1) {
            window.open('/Holidays/print-voucher/' + BookingData.BookingURLID + '?action=1&' + queryString, '_blank', 'noopener,noreferrer');
        } else if (formData.action === 2) {
            setisOpen(true);
        }

    }, [formData]);
    const ViewTicketDetails = () => {
        window.location.reload()
    }

    const [isOpen, setisOpen] = useState(false);
    const handleClose = () => {
        setisOpen(false);
        setProcessing(false)
    };
    const SendEditTicket = async () => {
        const response = await dispatch(
            DoSendVoucher({ formData, BookingURLID: BookingData.BookingURLID })
        ).unwrap();
        const { data } = response;
        if (data.status.success) {
            toast.success('Sent Mail Successfully', { autoClose: 2000 });
            setProcessing(false)
            setisOpen(false);
        } else {
            setProcessing(false)
            toast.error(data.message, { autoClose: 2000 });
        }
    }
    const handleConfirm = () => {
        setProcessing(true)

        if (formData.action == 2) {

            if (formData.emailid === '') {
                toast.error('Enter email id', { autoClose: 2000 });
                setProcessing(false)
                return false;
            }
            SendEditTicket()
        }
        return false
    };
    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };
    return (
        <>
            {DetailsLoading ? (
                <>
                    <div className="p-4">
                        <BookingReviewShimmer />
                    </div>
                </>
            ) : (
                <>

                    {isOpen && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                            <div className="bg-white rounded-md w-full max-w-md p-6 shadow-lg relative">
                                <div className="flex justify-between items-center mb-4 border-b pb-2">
                                    <h2 className="text-xl font-bold">{Titles}</h2>
                                    <button className="text-2xl font-semibold" onClick={handleClose}>&times;</button>
                                </div>
                                {formData.action == 2 && (
                                    <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium mb-1">Enter Email</label>
                                            <input type="email" name='emailid' onChange={handleChange} className="w-full border rounded-lg px-3 py-2" placeholder="Email ID" />
                                        </div>
                                    </div>
                                )}

                                <div className="text-right mt-4">
                                    <button disabled={Processing} onClick={handleConfirm} type='button' className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600 transition">
                                        {Processing ? (
                                            <span className="flex items-center">
                                                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Processing...
                                            </span>
                                        ) : (
                                            <>Submit</>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    <Dialog
                        open={isSectorModalOpen}
                        onClose={() => setIsModalSector(false)}
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
                    >
                        <div className="bg-white w-full max-w-md rounded-2xl shadow-lg p-6 flex flex-col items-center justify-center text-center">
                            {(() => {
                                if (errorMessageRecharge === "loading" || paymentHookStatusRecharge === 'loading') {
                                    return (
                                        <>
                                            <h2 className="text-lg font-semibold border-b pb-2 w-full text-center">
                                                Payment Process...
                                            </h2>
                                            <div className="mt-6 flex flex-col items-center justify-center">
                                                <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                                <p className="mt-4 text-gray-600">
                                                    Please do not go back or press any button. <br />
                                                    This might take a few seconds.
                                                </p>
                                            </div>
                                        </>
                                    )
                                } else if (errorMessageRecharge === "paymentfailed") {
                                    return (
                                        <>
                                            <CircleX className="w-16 h-16 text-red-500 mb-4" />
                                            <h2 className="text-xl font-bold text-red-600">
                                                Payment Failed
                                            </h2>
                                            <p className="mt-2 text-gray-700">
                                                {errorMessageRecharge}!<br />
                                                <span className="font-medium"> note down these Id for further support. RefId: </span>. <br />
                                                {BookingData?.BookingID} 😞
                                            </p>
                                            <button
                                                onClick={() => setIsModalSector(false)}
                                                className="mt-6 bg-blue-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition"
                                            >
                                                Try Again
                                            </button>
                                        </>
                                    )
                                } else if (errorMessageRecharge === "success" && paymentHookStatusRecharge === 'success') {
                                    return (
                                        <>
                                            <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
                                            <h2 className="text-xl font-bold text-green-600">
                                                Payment Success
                                            </h2>
                                            <p className="mt-2 text-gray-700">
                                                Due Payment Success with booking Id-<br />
                                                <span className="font-medium">{BookingData.BookingID}</span>. <br />
                                                Have a great trip 😍
                                            </p>
                                            <button
                                                onClick={ViewTicketDetails}
                                                className="mt-6 bg-green-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-green-700 transition"
                                            >
                                                View Details
                                            </button>
                                        </>
                                    )
                                } else if (errorMessageRecharge === "userCancelled" || errorMessageRecharge === "failure") {
                                    return (
                                        <>
                                            <CircleX className="w-16 h-16 text-red-500 mb-4" />
                                            <h2 className="text-xl font-bold text-red-600">
                                                Payment Failed
                                            </h2>
                                            <p className="mt-2 text-gray-700">
                                                {errorMessageRecharge}!<br />
                                                <span className="font-medium"> note down these Id for further support. RefId: </span>. <br />
                                                {BookingData?.BookingID} 😞
                                            </p>
                                            <button
                                                onClick={() => setIsModalSector(false)}
                                                className="mt-6 bg-blue-600 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition"
                                            >
                                                Try Again
                                            </button>
                                        </>
                                    )
                                }
                            })()}

                        </div>
                    </Dialog>
                    <div className="max-w-7xl mx-auto p-6 bg-gray-50 min-h-screen">
                        {/* Header Status */}

                        <div className="flex flex-wrap items-center justify-between bg-white border border-gray-200 rounded-xl p-5 shadow-sm mb-6">
                            <div className="flex items-center gap-3">
                                {BookingStatus === 1 ? (
                                    <>
                                        <CheckCircle className="w-10 h-10 text-green-500" />
                                        <h2 className="text-xl font-semibold text-green-600">
                                            Booking Successful
                                        </h2>
                                    </>
                                ) : BookingStatus === 3 ? (
                                    <>
                                        <XCircle className="w-10 h-10 text-red-500" />
                                        <h2 className="text-xl font-semibold text-red-600">
                                            Booking Failed
                                        </h2>
                                    </>
                                ) : (
                                    <>
                                        <Clock className="w-10 h-10 text-yellow-500" />
                                        <h2 className="text-xl font-semibold text-yellow-600">
                                            Booking Pending
                                        </h2>
                                    </>
                                )}
                            </div>

                            {/* Group buttons together */}
                            <div className="flex items-center gap-3">
                                <div className="col-md-4 text-right">
                                    {/* <button className="btn btn-primary btn-sm " type='button' onClick={shareOnWhatsApp}>CLick</button> */}
                                    {(BookingData?.status == 1 || BookingData?.status == 0 || BookingData?.status == 9 || BookingData?.status == 36) && (
                                        <div className="relative inline-block text-left">
                                            <button
                                                onClick={() => setOpen(!open)}
                                                className="inline-flex items-center px-4 py-2 bg-blue-500 text-white font-medium rounded-lg shadow hover:bg-blue-600 transition"
                                            >
                                                Voucher Options
                                                <ChevronDown className="w-4 h-4 ml-2" />
                                            </button>
                                            {open && (
                                                <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                                                    <div className="py-2">
                                                        <button onClick={() => handleOpen('Print Ticket', 1)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                                            Print Voucher
                                                        </button>
                                                        <button onClick={() => handleOpen('Email Ticket', 2)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                                            Email Voucher
                                                        </button>

                                                        {/* <button onClick={() => handleOpen('My Invoice', 8)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                                            My Invoice
                                                        </button>
                                                        <button onClick={() => handleOpen('Customer Invoice', 9)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                                            Customer Invoice
                                                        </button>
                                                        {user?.UserData?.user?.UserType == 2 && (
                                                            <>
                                                                <button onClick={() => handleOpen('Edit Transaction Fee', 6)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                                                    Edit Transaction Fee
                                                                </button>
                                                                <button onClick={() => handleOpen('Add Discount', 7)} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                                                    Add Discount
                                                                </button>
                                                            </>
                                                        )}

                                                        <a target='_blank' href={`/holidays/amendment/${BookingData?.BookingID}`} className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100">
                                                            Raise Cancellation
                                                        </a> */}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            {/* Left Column */}
                            <div className="lg:col-span-2 space-y-6">
                                {/* Hotel Details Card */}
                                <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
                                    <div className="bg-white rounded-lg shadow-sm p-3 border border-gray-100">
                                        <div className="flex flex-col md:flex-row gap-4">
                                            <div className="w-full md:w-1/3">
                                                <Image
                                                    src={BookingData?.Photo + "?q=80&w=1000&auto=format&fit=crop"}
                                                    alt={BookingData?.PackageName}
                                                    fallback={`/placeholder.png`}
                                                    className="img-fluid rounded align-top"
                                                />
                                            </div>
                                            <div className="flex-1">
                                                <div className="flex justify-between items-start">
                                                    <div>
                                                        <h3 className="text-lg font-bold text-gray-900">{BookingData?.PackageName}</h3>
                                                        <div className="flex items-center text-blue-500 text-sm mt-1">
                                                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" /></svg>
                                                            <span>{BookingData?.package?.des_city_name} {BookingData?.package?.country?.name} ({BookingData?.package?.PackageDuration})</span>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2 text-sm text-gray-600">
                                                        <span className="flex items-center"><svg className="w-4 h-4 mr-1 text-blue-800" fill="currentColor" viewBox="0 0 20 20"><path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" /></svg> {BookingData?.package?.PackageDuration} Nights</span>
                                                        <span className="flex items-center"><svg className="w-4 h-4 mr-1 text-yellow-500" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" /></svg> {parseInt(BookingData?.package?.PackageDuration) + 1} Days</span>
                                                    </div>
                                                </div>

                                                <div className="flex items-center mt-4 text-sm text-gray-700">
                                                    <div>
                                                        <p className="text-xs text-gray-500">Check-In</p>
                                                        <p className="font-semibold">{checkindate}</p>
                                                    </div>
                                                    <div className="mx-4 flex flex-col items-center">
                                                        <span className="text-xs text-gray-400">{BookingData?.package?.PackageDuration} Nights</span>
                                                        <div className="w-16 h-px bg-gray-300 relative">
                                                            <div className="absolute -top-1 -right-1 w-2 h-2 border-r border-t border-gray-300 transform rotate-45"></div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <p className="text-xs text-gray-500">Check-Out</p>
                                                        <p className="font-semibold">{checkoutDate}</p>
                                                    </div>
                                                </div>

                                                <div className="mt-4 flex gap-8 text-sm">
                                                    <div>
                                                        <p className="text-xs text-gray-500">Guests Details</p>
                                                        <p className="font-semibold">{BookingData?.adult} Adult, {BookingData?.child} Child {BookingData?.infant} Infant</p>
                                                    </div>
                                                    <div>
                                                        <p className="text-xs text-gray-500">Price Category</p>
                                                        <p className="font-semibold">{BookingData?.category?.name} {BookingData?.rooms} Room(s)</p>
                                                    </div>
                                                </div>
                                                <div className="mt-4 flex gap-8 text-sm">
                                                    <div>
                                                        <p className="text-xs text-gray-500">Booking ID</p>
                                                        <p className="font-semibold">#{BookingData?.BookingID}</p>
                                                    </div>
                                                    <div>
                                                        <p className="text-xs text-gray-500">Customer</p>
                                                        <p className="font-semibold">{BookingData?.customer?.name} </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-xs text-gray-500">Contact</p>
                                                        <p className="font-semibold">+{BookingData?.customer?.countrycode} {BookingData?.customer?.mobile} </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-2 pt-2 border-t border-blue-50 flex justify-between text-sm bg-blue-50/50 p-2 rounded">
                                            <button type="button" onClick={() => setShowCan(!showCan)} className="text-blue-600 underline uppercase">{showCan ? 'See less' : 'CANCELLATION POLICY'}</button>
                                            <button type="button" onClick={() => setShowItin(!showItin)} className="text-blue-600 uppercase underline">{showItin ? 'See less' : 'Review Your Itinerary'}</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-lg shadow-sm p-3 border border-gray-100">
                                    <h3 className="text-lg font-bold mb-2">Lead Guest</h3>
                                    <div className="">
                                        <div className="rounded-lg overflow-hidden mt-2">
                                            {/* HEADER */}
                                            <div className="p-2 flex justify-between items-center cursor-pointer">
                                                <div className="flex items-center gap-2">
                                                    {/* Guest Icon */}
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth="1.5"
                                                        stroke="currentColor"
                                                        className="w-5 h-5 text-blue-600"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.5 20.25a7.5 7.5 0 0 1 15 0"
                                                        />
                                                    </svg>

                                                    <span className="font-semibold text-gray-800 text-sm">
                                                        <span className="text-gray-500 font-normal"> {memberDetails[0]?.title}. {memberDetails[0]?.fname} {memberDetails[0]?.lname}</span>
                                                    </span>

                                                </div>
                                                <span className="font-semibold text-gray-800 text-sm">
                                                    <span className="text-gray-500 font-normal"> Mobile: {data.countryCode} {data.mobile}</span>
                                                    <span className="text-gray-500 font-normal"> Email : {data.email}</span>
                                                </span>
                                            </div>
                                        </div>
                                        {data.gstnnumber && (
                                            <div className=" rounded-lg overflow-hidden border border-blue-100 mt-2">
                                                <div className="px-1 py-2 bg-blue-100 flex justify-between items-center">
                                                    <div className="flex items-center gap-2">
                                                        <img width="20" className="mx-1" src="https://dhiz4uvf5rpaq.cloudfront.net/HOLIDAYSIN/V1/t6/svg-icon/GSTIN.svg"></img>
                                                        <span className="font-semibold text-gray-800 text-sm">GSTIN Details</span>
                                                    </div>
                                                    <div className="text-xs text-gray-500">Please include my GST number</div>
                                                </div>
                                                <div className="p-3">
                                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                                        <div>
                                                            <label className="text-xs text-gray-500 block mb-1">GSTIN</label>
                                                            {data.gstnnumber}
                                                        </div>
                                                        <div>
                                                            <label className="text-xs text-gray-500 block mb-1">Company name</label>
                                                            {data.companyname}
                                                        </div>
                                                        <div>
                                                            <label className="text-xs text-gray-500 block mb-1">Registered Email</label>
                                                            {data.gstemail}
                                                        </div>
                                                        <div>
                                                            <label className="text-xs text-gray-500 block mb-1">Registered Phone</label>
                                                            {data.gstphone}
                                                        </div>
                                                        <div>
                                                            <label className="text-xs text-gray-500 block mb-1">Registered Address</label>
                                                            {data.gstaddress}
                                                        </div>
                                                        <div>
                                                            <label className="text-xs text-gray-500 block mb-1">Registered State (optional)</label>
                                                            {data.gststate}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* Hotel Description Card */}

                            </div>

                            {/* Right Column - Fare Summary */}
                            <div className="lg:col-span-1">
                                <div className="bg-white border border-gray-200 rounded-xl p-2 shadow-sm sticky top-6">
                                    <div className="px-4 py-3 border-b border-gray-100 flex rounded-xl justify-between items-center bg-blue-50">
                                        <h3 className="font-bold text-gray-800">Fare Summary</h3>
                                        <span className="text-blue-500 text-xs font-semibold">{parseInt(BookingData?.adult) + parseInt(BookingData?.child) + parseInt(BookingData?.infant)} Guests</span>
                                    </div>
                                    <div className="p-4 space-y-2 text-sm">
                                        <div className="flex justify-between items-center text-gray-600">
                                            <div className="flex items-center gap-2">
                                                <span>Package Cost</span>
                                                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path></svg>
                                            </div>
                                            <span><CurFt currency={BookingData?.currency?.name || 'INR'} price={(PackagePrice?.base_price + PackagePrice?.markupAmount) - PackagePrice?.flightFare} /></span>
                                        </div>
                                        {PackagePrice?.flightFare > 0 && (
                                            <div className="flex justify-between items-center text-gray-600">
                                                <span className="">Flight Fare </span>
                                                <span><CurFt currency={BookingData?.currency?.name || 'INR'} price={PackagePrice?.flightFare} /></span>
                                            </div>
                                        )}
                                        <div className="flex justify-between items-center text-gray-600">
                                            <span className="">Discount </span>
                                            <span><CurFt currency={BookingData?.currency?.name || 'INR'} price={PackagePrice?.discount_amount} /></span>
                                        </div>
                                        <div className="flex justify-between items-center text-gray-600 font-medium">
                                            <span className="">Cost After Discount</span>
                                            <span><CurFt currency={BookingData?.currency?.name || 'INR'} price={PackagePrice?.discounted_price} /></span>
                                        </div>
                                        <div className="flex justify-between items-center text-gray-600">
                                            <span className="">GST/Tax </span>
                                            <span><CurFt currency={BookingData?.currency?.name || 'INR'} price={PackagePrice?.total_tax + PackagePrice?.GSTonMarkup} /></span>
                                        </div>
                                        <div className="flex justify-between items-center font-bold text-gray-800">
                                            <span className="">Total Amount</span>
                                            <span><CurFt currency={BookingData?.currency?.name || 'INR'} price={PackagePrice?.finalPrice} /></span>
                                        </div>
                                    </div>
                                    {PackagePrice?.discount_amount > 0 && (
                                        <div className="p-2 px-4 bg-green-50 flex justify-between items-center text-sm">
                                            <div className="flex items-center gap-1 text-green-600 font-medium">
                                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                                                Discount Applied
                                            </div>
                                            <span className="text-green-600 font-bold"><CurFt currency={BookingData?.currency?.name || 'INR'} price={PackagePrice?.discount_amount} /></span>
                                        </div>
                                    )}
                                    <div className="p-2 px-4 bg-green-50 flex justify-between items-center text-sm mt-2">
                                        <div className="flex items-center gap-1 text-green-600 font-medium">
                                            Received Amount
                                        </div>
                                        <span className="text-green-600 font-bold"><CurFt currency={BookingData?.currency?.name || 'INR'} price={BookingData?.ReceivedAmount} /></span>
                                    </div>
                                    {(PackagePrice?.finalPrice - BookingData?.ReceivedAmount) > 0 && (
                                        <div className="p-2 px-4 bg-orange-50 flex justify-between items-center text-sm mt-2">
                                            <div className="flex items-center gap-1 text-orange-600 font-medium">
                                                Pending Amount
                                            </div>
                                            <span className="text-orange-600 font-bold"><CurFt currency={BookingData?.currency?.name || 'INR'} price={PackagePrice?.finalPrice - BookingData?.ReceivedAmount} /></span>
                                        </div>
                                    )}
                                    <div className="p-4 rounded-xl mt-2 bg-gray-100 flex justify-between items-center border-t border-gray-200">
                                        <span className="font-bold text-gray-800">Grand Total</span>
                                        <span className="font-bold text-xl text-gray-900"><CurFt currency={BookingData?.currency?.name || 'INR'} price={Math.ceil(PackagePrice?.finalPrice)} /></span>
                                    </div>
                                    {(PackagePrice?.finalPrice - BookingData?.ReceivedAmount) > 0 && (
                                        <div className="p-2 px-4 flex justify-between items-center text-sm mt-2">
                                            <button
                                                variant="contained"
                                                size="large"
                                                type="button"

                                                onClick={() => setOpenPaynow((v) => !v)}
                                                disabled={Processing}
                                                className={`px-5 py-2 w-full rounded-lg bg-red-500 hover:bg-red-600 text-white font-medium shadow transition ${Processing
                                                    ? 'bg-gray-400 cursor-not-allowed'
                                                    : 'bg-red-500 hover:bg-red-600'
                                                    }`}
                                            >
                                                Pay Pending <CurFt currency={BookingData?.currency?.name || "INR"} price={PackagePrice?.finalPrice - BookingData?.ReceivedAmount} />

                                            </button>
                                        </div>
                                    )}


                                    {OpenPaynow && (PackagePrice?.finalPrice - BookingData?.ReceivedAmount) > 0 && (
                                        <form onSubmit={handleSubmit} className="mui-form">
                                            <div className="mt-3  ml-auto shadow p-4 rounded-lg">
                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-600">
                                                            Booking ID
                                                        </label>
                                                        <input
                                                            type="text"
                                                            value={BookingData.BookingID}
                                                            readOnly
                                                            className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                                            placeholder="Booking ID"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-600">
                                                            Pending Amount
                                                        </label>
                                                        <input
                                                            type="text"
                                                            value={Number.parseFloat(PackagePrice?.finalPrice - BookingData?.ReceivedAmount).toFixed(2)}
                                                            readOnly
                                                            className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                                            placeholder="Pending Amount"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-600">
                                                            Remark
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="mt-1 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 focus:bg-white transition-all"
                                                            placeholder="Remark"
                                                            name="remark"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-sm font-medium text-gray-600">
                                                            Payment Mode
                                                        </label>
                                                        <label
                                                            htmlFor="FullPay"
                                                            className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                                                        >
                                                            <input
                                                                type="radio"
                                                                id="FullPay"
                                                                value="1"
                                                                name="paymentMode"
                                                                onChange={paymentModeHandle}
                                                                checked={paymentMode == 1}
                                                                className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                                                            />
                                                            <span className="text-sm font-medium text-gray-700">
                                                                Wallet
                                                            </span>
                                                        </label>
                                                    </div>
                                                    {/* <div>
                                                        <label className="block text-sm font-medium text-gray-600">
                                                            Payment Mode
                                                        </label>
                                                        <label
                                                            htmlFor="Part"
                                                            className="flex items-center space-x-2 cursor-pointer rounded-lg border border-gray-300 px-4 py-2 shadow-sm hover:border-blue-500 hover:shadow-md transition"
                                                        >
                                                            <input
                                                                type="radio"
                                                                id="Part"
                                                                value="2"
                                                                name="paymentMode"
                                                                onChange={paymentModeHandle}
                                                                checked={paymentMode == 2}
                                                                className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                                                            />
                                                            <span className="text-sm font-medium text-gray-700">
                                                                Online
                                                            </span>
                                                        </label>
                                                    </div> */}

                                                    <div className="flex gap-3">

                                                    </div>
                                                    <div className="flex gap-3">

                                                        <button
                                                            variant="contained"
                                                            size="large"
                                                            type="submit"
                                                            disabled={Processing}
                                                            className={`px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition ${Processing
                                                                ? 'bg-gray-400 cursor-not-allowed'
                                                                : 'bg-blue-500 hover:bg-blue-600'
                                                                }`}
                                                        >
                                                            {Processing ? (
                                                                <>
                                                                    Please wait...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    Proceed To Pay
                                                                </>

                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}



        </>
    );
};

export default Confirmation;